<script lang="ts">
  import { createEventDispatcher } from "svelte"
  import { chevronIcon } from "$app/utils"

  interface Props {
    field: string
    current: string
    label: string
    dir: "asc" | "desc"
    activeClass: string
    inactiveClass: string
    onsort: (field: string) => void
  }
  let props = $props()

  let {
    field,
    current,
    label = "",
    dir,
    activeClass = "text-blue-700",
    inactiveClass = "text-gray-700",
    onsort
  }: Props = props
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<button
  onclick={() => onsort(field)}
  class="cursor-pointer {current === field ? activeClass : inactiveClass}"
>
  <slot>{label}</slot>
  {#if current === field}
    <span class="ml-1 inline-block {dir}">
      {@html chevronIcon}
    </span>
  {/if}
</button>

<style>
  .asc {
    transform: rotate(180deg);
  }
</style>
